import React from 'react';
import { Reveal } from './Reveal';
export function Resonance() {
  return <section className="w-full bg-ivory py-24 sm:py-32 lg:py-44" aria-labelledby="resonance-title" data-id="element-227" data-mp="2tks28qhm188g">
      <div className="mx-auto grid max-w-page grid-cols-1 gap-14 px-5 sm:px-10 lg:grid-cols-[1.15fr_1fr] lg:items-center lg:gap-24 lg:px-12" data-id="element-228" data-mp="2otjstuga5mva">
        <Reveal data-id="element-229" data-mp="2kryjuk6v9sqd">
          <h2 id="resonance-title" className="font-sans text-[1.85rem] font-light uppercase leading-[1.15] tracking-[0.01em] text-ink sm:text-4xl xl:text-[2.9rem]" data-id="element-230" data-mp="2kqdoiscqa5rg">
            Tal vez no estás
            <br className="hidden sm:block" data-id="element-231" data-mp="25uxwesvpkjxp" /> buscando cambiarlo todo.
          </h2>
          <p className="mt-5 font-serif text-3xl italic leading-tight text-champagne sm:text-4xl xl:text-[2.9rem]" data-id="element-232" data-mp="21tm1q8xz98in">
            Tal vez estás abierto/a a algo más.
          </p>

          <div className="mt-10 max-w-lg space-y-6 font-sans text-[17px] font-light leading-relaxed text-steel sm:text-lg" data-id="element-233" data-mp="41qdl9gvzk72">
            <p data-id="element-234" data-mp="6stsiycz68a4">
              Quizás ya tienes un trabajo, un negocio, una familia o diferentes
              responsabilidades.
            </p>
            <p className="text-ink" data-id="element-235" data-mp="bsg5r7sszoix">
              Pero también sabes que quieres seguir creciendo, aprender algo
              nuevo y crear nuevas posibilidades para tu futuro.
            </p>
            <p data-id="element-236" data-mp="1u8r4vlzlik3">
              EXPANDE te invita a conocer un camino diferente dentro de la
              industria de servicios financieros, sin tener que cambiar de
              inmediato lo que hoy haces.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-237" data-mp="gqztndqyjadx">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/e85dfb04-dd2d-4dab-874a-4568bb912bb3.jpg" alt="Profesional mirando por la ventana de una oficina moderna con luz natural" className="h-[380px] w-full object-cover sm:h-[520px] lg:h-[620px]" data-id="element-238" data-mp="gpoqng5c66nv" />
        </Reveal>
      </div>
    </section>;
}